import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-accordion-modal-popup',
    templateUrl: './accordion-modal-popup.component.html',
    styleUrls: ['./accordion-modal-popup.component.scss'],
    standalone: false
})
export class AccordionModalPopupComponent extends CfetBaseComponent implements OnInit, OnChanges {

  userFacing = true;
  agentFacingDesc = true;
  mobileView = false;

  constructor() { super(); }

  @Input() selectedOrg: any;
  @Input() fname: string;
  @Input() lname: string;
  @Input() isEmpVolID: boolean;
  @Input() isEmpPay: boolean;
  @Input() isCert: boolean;
  @Input() isSignedLetter: boolean;
  @Input() docUploadAccordioanModal: boolean;
  @Output() accordionModalCloseEvent = new EventEmitter<any>();

  ngOnInit() {
    window.scrollTo(0, 0);
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      this.mobileView = true;
    }
  }

  ngOnChanges() {
    const devicewidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if ((navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) || (devicewidth <= 1024)) {
      if (this.docUploadAccordioanModal) {
        document.getElementById('progress-tracker').setAttribute('style', 'display:none');
        document.getElementsByClassName('customer_facing_header')[0].setAttribute('style', 'display:none');
        document.getElementById('footer-container').setAttribute('style', 'display:none');
      }
    }
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.docUploadAccordioanModal = false;
      this.accordionModalCloseEvent.emit('modalClose');
    }
  }
}
